export const FEATURE_STATUSES = {
  live: {
    label: 'Live',
    tone: 'live',
    description: 'Verified end-to-end in the current app.',
  },
  beta: {
    label: 'Beta',
    tone: 'beta',
    description: 'Usable, but still has known MVP caveats.',
  },
  comingSoon: {
    label: 'Coming Soon',
    tone: 'comingSoon',
    description: 'Visible as product direction, but not a complete launched workflow.',
  },
  internal: {
    label: 'Internal',
    tone: 'internal',
    description: 'Implemented for operators or future work, not launched as user-facing product.',
  },
};

export const FEATURES = {
  museumBrowsing: {
    name: 'Museum browsing',
    status: 'live',
  },
  personaChat: {
    name: 'Persona chat',
    status: 'beta',
  },
  oxfordDebate: {
    name: 'Oxford Chamber debates',
    status: 'beta',
  },
  customMind: {
    name: 'Summon a mind',
    status: 'beta',
  },
  customHallRequest: {
    name: 'Custom hall requests',
    status: 'comingSoon',
  },
  customHallGeneration: {
    name: 'Instant custom hall generation',
    status: 'comingSoon',
  },
  analyticsAdmin: {
    name: 'Analytics and admin review',
    status: 'internal',
  },
};

export const getFeatureStatus = (featureKey) => {
  const feature = FEATURES[featureKey];
  if (!feature) return FEATURE_STATUSES.comingSoon;
  return FEATURE_STATUSES[feature.status] || FEATURE_STATUSES.comingSoon;
};
